<!--
  DO NOT CHANGE the weird formatting between the TableCell tags. It is necessary to
  suppress the horizontal space introduced between inline-block elements by the browser.
-->
<template>
  <TableRow :id="tableRowId"
            class="table-row d-flex align-items-stretch lh-base"
            :class="tableRowClass"
            :style="`min-width: ${rowWidth}px;`"
            @click="selectEntryId(cruise, detailsPanelCollapsed, $event)"
            @dblclick="showDetails(cruise)">
    <TableCell :width="`${columnWidths.abfahrt}px`"
               class="position-relative d-inline-block align-top px-1">
      <div class="cursor-default">
        {{ cruise.abfahrt }}
      </div>
      <div class="cursor-default">
        {{ cruise.ankunft }}
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.route}px;`"
               class="position-relative d-inline-block align-top px-1">
      <span class="text-uppercase">{{ cruise.route }}</span>
      <div v-if="isCampaign(cruise)"
           class="fs-10 mt-1 color-sachlich-white">
        <span class="campaign-badge px-2 py-1 bg-aida-red">
          Aktion
        </span>
        <span class="campagin-tooltip position-fixed color-sachlich-black px-1 border border-sachlich-black fs-10 bg-sachlich-white">
          {{ campaigns }}
        </span>
      </div>

      <div v-if="amenity"
           class="my-2">
        <span class="color-informativ-darkgreen bg-informativ-middlegreen fw-bold fs-10 px-2 py-1">
          {{ amenity }}
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.dauer}px`"
               class="text-center position-relative d-inline-block align-top px-1">
      <span>{{ cruise.dauer }}</span>
    </TableCell>
    <TableCell :width="`${columnWidths.schiff}px`"
               class="text-center position-relative d-inline-block align-top px-1">
      <span>{{ cruise.schiff }}</span>
    </TableCell>
    <TableCell :width="`${columnWidths.flüge}px`"
               class="position-relative d-inline-block align-top px-1">
      <span v-for="(airport, index) in airports"
            :key="index"
            class="airport d-inline-block">
        <div class="bullet d-inline-block rounded-circle"
             :class="!!airport.outbound ? 'bg-aida-green' : 'bg-aida-red'" />
        <div class="bullet d-inline-block rounded-circle"
             :class="airport.inbound ? 'bg-aida-green' : 'bg-aida-red'" />{{ airport.key }}
      </span>

      <div v-if="cruise.hasFlexFlight"
           class="fs-10 mt-1 mb-2">
        <span class="bg-expinet-darkblue color-sachlich-white px-2 py-1">
          Wunschflug buchbar
        </span>
      </div>
    </TableCell>

    <TableCell :width="`${columnWidths.bett}px`"
               class="text-center position-relative d-inline-block align-top px-1">
      <span v-for="(mainCode, index) in mainCodes"
            :key="index">
        {{ mainCode }}
        <br>
      </span>
    </TableCell>
    <TableCell :width="`${columnWidths.premium_all_inclusive}px`"
               class="position-relative d-inline-block align-top px-1">
      <div v-for="(mainCode, index) in mainCodes"
           :key="index">
        <span class="price d-inline-block fw-bold text-end pe-1"
              :class="{
                'color-sachlich-grey': !cruise.comai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinPrice],
              }">
          <div>{{ formatPrice(cruise.comai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
        <span :ref="'cruise-list-row-cheapest-flight-comfortai-' + mainCode"
              class="price d-inline-block fw-bold text-end pe-1"
              :class="{ 'color-sachlich-grey': !cruise.comai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] }">
          <div>{{ formatPrice(cruise.comai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.premium_all_inclusive}px`"
               class="position-relative d-inline-block align-top px-1">
      <div v-for="(mainCode, index) in mainCodes"
           :key="index">
        <span class="price d-inline-block fw-bold text-end pe-1"
              :class="{
                'color-sachlich-grey': !cruise.indai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinPrice],
              }">
          <div>{{ formatPrice(cruise.indai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
        <span :ref="'cruise-list-row-cheapest-flight-premiumai-' + mainCode"
              class="price d-inline-block fw-bold text-end pe-1"
              :class="{ 'color-sachlich-grey': !cruise.indai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] }">
          <div>{{ formatPrice(cruise.indai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.premium}px`"
               class="position-relative d-inline-block align-top px-1">
      <div v-for="(mainCode, index) in mainCodes"
           :key="index">
        <span class="price d-inline-block fw-bold text-end pe-1"
              :class="{
                'color-sachlich-grey': !cruise.ind.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinPrice],
              }">
          <div>{{ formatPrice(cruise.ind.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
        <span :ref="'cruise-list-row-cheapest-flight-premium-' + mainCode"
              class="price d-inline-block fw-bold text-end pe-1"
              :class="{ 'color-sachlich-grey': !cruise.ind.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] }">
          <div>{{ formatPrice(cruise.ind.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.classic_all_inclusive}px`"
               class="position-relative d-inline-block align-top px-1">
      <div v-for="(mainCode, index) in mainCodes"
           :key="index">
        <span class="price d-inline-block fw-bold text-end pe-1"
              :class="{
                'color-sachlich-grey': !cruise.claai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinPrice],
              }">
          <div>{{ formatPrice(cruise.claai.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
        <span :ref="'cruise-list-row-cheapest-flight-classicai-' + mainCode"
              class="price d-inline-block fw-bold text-end pe-1"
              :class="{ 'color-sachlich-grey': !cruise.claai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] }">
          <div>{{ formatPrice(cruise.claai.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.classic}px`"
               class="position-relative d-inline-block align-top px-1">
      <div v-for="(mainCode, index) in mainCodes"
           :key="index">
        <span class="price d-inline-block fw-bold text-end pe-1"
              :class="{
                'color-sachlich-grey': !cruise.cla.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinPrice],
              }">
          <div>{{ formatPrice(cruise.cla.cabinPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
        <span :ref="'cruise-list-row-cheapest-flight-classic-' + mainCode"
              class="price d-inline-block fw-bold text-end pe-1"
              :class="{ 'color-sachlich-grey': !cruise.cla.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] }">
          <div>{{ formatPrice(cruise.cla.cabinFlightPrice[(mainCode === 'V' ? 'B' : mainCode) as keyof ICabinFlightPrice] ?? null) }}</div>
        </span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.specials}px`"
               class="fs-10 position-relative d-inline-block align-top px-1">
      <div>
        <i class="fa fw-bold"
           :class="!cruise['pauai'].categories ? 'color-sachlich-grey fa-times-circle' : 'fa-check-circle color-informativ-darkgreen'" />
        <span class="fw-bold"
              :class="!cruise['pauai'].categories ? 'color-sachlich-grey' : ''">PAUSCHAL ALL IN</span>
      </div>
      <div>
        <i class="fa fa-times-circle fw-bold"
           :class="!cruise['pau'].categories ? 'color-sachlich-grey fa-times-circle' : 'fa-check-circle color-informativ-darkgreen'" />
        <span class="fw-bold"
              :class="!cruise['pau'].categories ? 'color-sachlich-grey' : ''">PAUSCHAL</span>
      </div>
      <div>
        <i class="fa fa-times-circle fw-bold"
           :class="!cruise.lig.categories ? 'color-sachlich-grey fa-times-circle' : 'fa-check-circle color-informativ-darkgreen'" />
        <span class="fw-bold"
              :class="!cruise.lig.categories ? 'color-sachlich-grey' : ''">LIGHT</span>
      </div>
    </TableCell>
    <TableCell :width="`${columnWidths.button}px`"
               class="row-cell position-relative d-inline-block align-top px-1">
      <Icon class="details-button position-absolute me-2"
            type="right"
            @click="showDetails(cruise)" />
    </TableCell>
  </TableRow>
</template>

<script lang="ts">
import { handleError } from '@/general/errorHandling'
import { useCruiseStore, useDetailsStore, useFilterStore, useUiStore } from '@/store'
import { IDomainList } from '@/store/app/interfaces'
import { useCruiseListStore } from '@/store/cruise-list'
import { ICabinFlightPrice, ICabinPrice, IMapCruiseGridResult, IPrice } from '@/store/cruise-list/interfaces'
import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { PropType } from 'vue'
import { COLUMN_WIDTHS } from '../../general/helper'
import { CLASSIC, CLASSICAI, COMFORTAI, IND, INDAI, LIGHT, PAUSCHAL, PAUSCHALAI } from '../../general/master-data'
import Icon from '../common/Icon.vue'
import { IMapCruiseListResult } from '../interfaces'
import TableCell from './TableCell.vue'
import TableRow from './TableRow.vue'

const DASH = '\u2013'

/* eslint-disable no-bitwise */

export default {
  name: 'CruiseListRow',
  components: { TableRow, TableCell, Icon },

  props: {
    cruise: { type: Object as PropType<IMapCruiseGridResult>, required: true },
    highlighted: { type: Boolean, default: false },
    even: { type: Boolean, default: false },
    referenceId: { type: Number, default: null },
    rowWidth: { type: Number, default: 0 },
  },

  data: () => {
    return {
      columnWidths: COLUMN_WIDTHS,
    }
  },

  computed: {
    ...mapState(useCruiseStore, {
      selectedCruise: store => store.cruise,
    }),
    ...mapState(useFilterStore, {
      filterFields: store => store.filterFields,
      paxConfig: store => store.paxConfig
    }),
    ...mapState(useUiStore, {
      detailsPanelCollapsed: store => store.detailsPanelCollapsed,
    }),
    ...mapWritableState(useCruiseListStore, {
      selectedEntryId: 'selectedEntryId'
    }),

    tableRowId() {
      return 'cruise-list-row-' + this.referenceId
    },

    tableRowClass() {
      if (this.highlighted) {
        return 'highlighted-row'
      } else if (this.even) {
        return 'bg-expinet-background'
      }

      return ''
    },

    airports() {
      const airports = []

      for (const [key, value] of Object.entries(this.cruise.flüge)) {
        if (!!value.inbound || !!value.outbound) {
          airports.push({
            key,
            inbound: value.inbound,
            outbound: value.outbound,
          })
        }
      }

      return airports
    },

    mainCodes() {
      const mainCodes = ['I', 'M']

      if (!mainCodes.includes(this.cruise.displayB) && !!this.cruise.displayB) {
        mainCodes.push(this.cruise.displayB)
      }

      if (this.displaySuite(this.cruise)) {
        mainCodes.push('S')
      }

      return mainCodes
    },

    amenity() {
      const amenities = this.cruise.amenities

      if (!amenities.length) {
        return null
      }

      return amenities[0].name ?? amenities[0].description ?? null
    },

    campaigns() {
      return this.cruise.campaigns.join('| ')
    },
  },

  methods: {
    ...mapActions(useUiStore, {
      showDetailsPanel: 'showDetailsPanel',
      setDetailsPanelActiveTab: 'setDetailsPanelActiveTab'
    }),
    ...mapActions(useDetailsStore, {
      fetchDetails: 'fetchDetails'
    }),

    formatPrice: (amount: number | null) => {
      if (!amount) {
        return DASH + ' €'
      }

      let amountString = String(Math.round(amount))
      const len = amountString.length
      const len3 = len - 3

      if (len > 3) {
        amountString = amountString.substring(0, len3) + '.' + amountString.substring(len3)
      }

      return amountString + ' €'
    },

    async showDetails(entry: IMapCruiseListResult) {
      if (process.env.STAGE === 'prod') {
        this.sendIntent(entry.id)
      }

      this.showDetailsPanel()

      const isNewSelection = !this.selectedCruise || entry.id !== this.selectedCruise.id

      if (!isNewSelection) return

      this.selectedEntryId = entry.id

      this.setDetailsPanelActiveTab('overview')

      await this.fetchDetails(entry.id, this.paxConfig, entry.flüge)
    },

    selectEntryId(entry: IMapCruiseListResult, isDetailsPanelCollapsed: boolean, event: any) {
      const isDoubleClick = event.detail > 1
      const isNewSelection = !this.selectedCruise || entry.id !== this.selectedCruise.id

      if (isDoubleClick) return

      if (isNewSelection) {
        this.selectedEntryId = entry.id

        this.setDetailsPanelActiveTab('overview')
      }

      if (!isDetailsPanelCollapsed) {
        this.showDetails(entry)
      }
    },

    sendIntent: async (cruiseId: string) => {
      const domainlist = {
        prod: 'https://my.aida.de',
        test: 'https://stage.aida.de',
        dev: 'https://stage.aida.de',
      }
      const domain = domainlist[process.env.STAGE as keyof IDomainList]

      try {
        const intentPath = encodeURIComponent(`${domain}/finden/${cruiseId}/`)
        const uri = `${domain}/api/v0/intent?url=${intentPath}&source=expinet`
        const options: RequestInit = { cache: 'no-cache', method: 'POST', mode: 'cors' }
        const request = new Request(uri)
        await fetch(request, options)
      } catch (error) {
        handleError({ error, origin: 'sendIntent' })
      }
    },

    isCampaign: (entry: IMapCruiseListResult) => {
      return !!entry.campaigns.length
    },

    onlySuitesAvailable: (entry: IMapCruiseListResult, priceModelCode: IbePriceModelCode) => {
      const priceModel = priceModelCode.toLowerCase() as keyof IMapCruiseGridResult
      const priceModelEntry = entry[priceModel] as IPrice

      const cabinPricesZero =
        priceModelEntry.cabinPrice.I === 0 &&
        priceModelEntry.cabinPrice.M === 0 &&
        priceModelEntry.cabinPrice.B === 0

      const cabinFlightPricesZero =
        priceModelEntry.cabinFlightPrice.I === 0 &&
        priceModelEntry.cabinFlightPrice.M === 0 &&
        priceModelEntry.cabinFlightPrice.B === 0

      return cabinPricesZero && cabinFlightPricesZero
    },

    displaySuite(entry: IMapCruiseListResult) {
      const filterHasSuite = !!this.filterFields.categories.value && this.filterFields.categories.value.includes('S')

      let onlySuitesAvailable = true
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, COMFORTAI)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, INDAI)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, IND)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, CLASSICAI)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, CLASSIC)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, PAUSCHAL)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, PAUSCHALAI)
      onlySuitesAvailable = onlySuitesAvailable && this.onlySuitesAvailable(entry, LIGHT)

      return filterHasSuite || onlySuitesAvailable
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

span,
.cursor-default {
  cursor: default;
}

.table-row {
  min-height: 76px;
}

.airport {
  width: 46px;
}

.bullet {
  width: 6px;
  height: 6px;
  margin-bottom: 2px;
  margin-right: 1px;
}

.price {
  width: 65px;
}

.highlighted-row {
  // TODO: try bootstraps shade-color()
  background-color: $color-expinet-selected;
}

.campaign-badge {
  +.campagin-tooltip {
    display: none;
  }

  &:hover+.campagin-tooltip {
    display: block;
    transform: translate(47%, 0);
    z-index: 200;
  }
}

.details-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
